// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"CZ-z","sponsoredTooltipWrapper":"DZ-z","sponsoredTooltip":"EZ-z","newCard":"FZ-z"};